import { useQuery } from "@tanstack/react-query";
import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { useApi } from "../../shared/api/index";

export const useFetchStandingConfiguration = () => {
  const { fetchData } = useApi();
  const { organizationId, sport, standingConfigurationId } = useParams();

  return useQuery({
    queryKey: ["standingsConfigurations", organizationId, standingConfigurationId],
    queryFn: async () => {
      const result = await fetchData({
        url: `${sport}/o/${organizationId}/standings/configurations/${standingConfigurationId}`,
      });
      return result?.data?.[0];
    },
    enabled: !!standingConfigurationId,
  });
};

export const useFetchStandingsConfigurations = (params = {}) => {
  const { fetchData } = useApi();
  const { organizationId, sport } = useParams();
  let URL = `${sport}/o/${organizationId}/standings/configurations`;
  if (!isEmpty(params)) {
    URL += `?${new URLSearchParams(params)?.toString()}`;
  }

  return useQuery({
    queryKey: ["standingsConfigurations", organizationId, JSON.stringify(params)],
    queryFn: async () => {
      const result = await fetchData({
        url: URL,
      });
      return result?.data || [];
    },
  });
};
